// extracted by mini-css-extract-plugin
export default {"products":"ws-z","card":"xs-z","oosMessaging":"ys-z"};